import React from "react";
import mealsImage from "../../assets/meals.jpg";
import classes from "./Header.module.css"
import HeaderCartButton from "./HeaderCartButton";

const Header = (props) => {
  return (
    <>
      <hesder className={classes.header} >
        <h1>React Meals</h1>
        <HeaderCartButton onClick={props.onShowCart} />
      </hesder>
      <div className={classes['main-image']} >
        <img src={mealsImage} alt="A table of delicious food!" />
      </div>
    </>
  );
};

export default Header;
